/**
 * Redirects workspace role USER to /agentic — Network Workbench and related shell routes are CREATOR+ only.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext.jsx';
import { canAccessNetworkWorkbench } from '@/utils/stepflowRoles';

export default function RequiresNetworkWorkbenchAccess({ children }) {
  const { workspaceRole } = useAuth();
  if (!canAccessNetworkWorkbench(workspaceRole)) {
    return <Navigate to="/agentic" replace />;
  }
  return children;
}
